import React from "react"
import styled from "styled-components"
import { connect } from "react-redux"
import { Link } from "react-router-dom"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import authorSrc from "assets/images/author.jpg"
import { menuData } from "utils/data"

const Container = styled.div`
		width: 240px;
		height: 100%;
		background: #efefef;
		transition: 0.3s;
		position: absolute;
		left: ${(props) => (props.show ? "0" : "-240px")};
		z-index: 66;
	`,
	UserWrap = styled.div`
		padding: 30px 0;
		text-align: center;
		background: #111111;
	`,
	Avatar = styled.img`
		width: 100px;
		padding: 4px;
		background: #fff;
		border-radius: 50%;
	`,
	NickName = styled.h2`
		padding: 6px 0;
		color: #fff;
		font-size: 20px;
	`,
	Nav = styled.div``,
	NavItem = styled(Link)`
		padding: 6px 20px;
		text-decoration: none;
		display: flex;
		flex-direction: row;
		align-items: center;
		position: relative;
	`,
	ItemWrap = styled.div`
		${(props) => (props.use === "icon" ? "width: 50px;" : "")}
		${(props) => (props.use === "title" ? "color: #576b88;" : "")}
	`,
	ItemIcon = styled(FontAwesomeIcon)`
		color: #576b88;
		font-size: 18px;
	`,
	ItemCTitle = styled.h3`
		font-size: 16px;
		font-weight: bold;
		line-height: 22px;
	`,
	ItemETitle = styled.p`
		font-size: 13px;
		line-height: 18px;
	`

function Sidebar(props) {
	return (
		<Container show={props.sideShow}>
			<UserWrap>
				<Avatar src={authorSrc} />
				<NickName>stempest</NickName>
			</UserWrap>
			<Nav>
				{menuData.map((item, index) => (
					<NavItem key={index} to="/" onClick={() => props.sidebarHandle()}>
						<ItemWrap use="icon">
							<ItemIcon icon={item.icon} />
						</ItemWrap>
						<ItemWrap use="title">
							<ItemCTitle>{item.cTitle}</ItemCTitle>
							<ItemETitle>{item.eTitle}</ItemETitle>
						</ItemWrap>
					</NavItem>
				))}
			</Nav>
		</Container>
	)
}

export default connect(
	(state) => ({ sideShow: state.control.sideShow }),
	(dispatch) => ({
		sidebarHandle: () => dispatch({ type: "SIDESHOW_HANDLE" }),
	})
)(Sidebar)
